import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Redirector from './components/Redirector';  // Importe o componente que você criou
import './App.css';

const App = () => {
  return (
    <Router>
      <Routes>
        {/* A rota aqui captura o 'codigo' como parâmetro da URL e usa o componente Redirector */}
        <Route path="/:codigo" element={<Redirector />} />
      </Routes>
    </Router>
  );
};

export default App;
